"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _FileContainer = _interopRequireDefault(require("./FileContainer"));
var _Translations = require("../Translations");
var _core = require("@material-ui/core");
var _reactIntl = require("react-intl");
var _styles = require("@material-ui/core/styles");
var _colors = require("@material-ui/core/colors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _core.createMuiTheme)({
  palette: {
    primary: _colors.red
  }
});
var MultiFileUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiFileUploader, _React$Component);
  var _super = _createSuper(MultiFileUploader);
  function MultiFileUploader(props) {
    var _this;
    _classCallCheck(this, MultiFileUploader);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "fileInput", /*#__PURE__*/_react.default.createRef());
    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (item) {});
    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (item) {
      if (item.id && _this.props.onDelete) {
        _this.props.onDelete(item.id, _this.state.deletedFileIndex);
      }
      _this.setState(function (prevState) {
        return {
          deletedFileIndex: prevState.deletedFileIndex + 1,
          files: _toConsumableArray(prevState.files.filter(function (element) {
            return !_lodash.default.isEqual(element, item);
          }))
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        error: null
      });
      var files = _toConsumableArray(e.target.files);
      var hasError = false;
      // Validate file count
      if (_this.props.maxFiles) {
        var filesCount = _this.state.files.length + files.length;
        if (filesCount > _this.props.maxFiles) {
          _this.props.setFieldError(_this.props.name, "".concat(_this.props.intl.formatMessage({
            id: "Le nombre des fichiers doit être inferieur ou éguale à",
            defaultMessage: "Le nombre des fichiers doit être inferieur ou éguale à"
          }), " ").concat(_this.props.maxFiles));
          _this.props.setFieldTouched(_this.props.name, true, false);
          hasError = true;
        }
      }
      // Validate size of each file
      if (_this.props.maxSize) {
        files.forEach(function (file) {
          if (file.size >= _this.props.maxSize) {
            _this.props.setFieldError(_this.props.name, "".concat(_this.props.intl.formatMessage({
              id: "La taille de fichier doit être inférieure à",
              defaultMessage: "La taille de fichier doit être inférieure à"
            }), " ").concat(_this.props.maxSize / 1000000, " MB"));
            _this.props.setFieldTouched(_this.props.name, true, false);
            hasError = true;
          }
        });
      }
      // Validate the sum of all files
      if (_this.props.maxTotalSize) {
        var size = 0;
        files.forEach(function (file) {
          return size = size + file.size;
        });
        if (size >= _this.props.maxTotalSize) {
          _this.props.setFieldError(_this.props.name, "".concat(_this.props.intl.formatMessage({
            id: "La taille des fichiers doit être inférieure à",
            defaultMessage: "La taille des fichiers doit être inférieure à"
          }), " ").concat(_this.props.maxTotalSize / 1000000, " MB"));
          _this.props.setFieldTouched(_this.props.name, true, false);
          hasError = true;
        }
      }
      if (!hasError) {
        _lodash.default.forOwn(files, function (file, index) {
          if (_this.props.acceptedFiles.indexOf(file.type) !== -1) {
            _this.setState(function (prevState) {
              return {
                files: [].concat(_toConsumableArray(prevState.files), [{
                  file: file
                }]),
                isProcessing: false
              };
            });
          } else {
            _this.props.setFieldError(_this.props.name, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: "Format de fichier non pris en charge.",
              defaultMessage: "Format de fichier non pris en charge."
            }));
            _this.props.setFieldTouched(_this.props.name, true, false);
          }
        });
      }
      e.target.value = null;
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddFileClick", function () {
      _this.fileInput.current.click();
    });
    _this.state = {
      deletedFileIndex: 0,
      error: null,
      files: [],
      isProcessing: false
    };
    return _this;
  }
  _createClass(MultiFileUploader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var value = this.props.value;
      if (value && value.length > 0) {
        this.setState({
          files: value
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.onChange && this.state.files.length !== prevState.files.length) {
        var files = this.state.files.length === 0 ? null : this.state.files;
        this.props.setFieldValue(this.props.name, files);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        label = _this$props.label,
        acceptedFiles = _this$props.acceptedFiles,
        disabled = _this$props.disabled;
      var existingFiles = this.state.files.length !== 0;
      var canAddAnotherFile = true;
      if (this.props.maxFiles) {
        canAddAnotherFile = this.state.files.length < this.props.maxFiles;
      }
      return /*#__PURE__*/_react.default.createElement("div", null, this.state.files.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_FileContainer.default, {
          disabled: disabled,
          key: index,
          label: "abc",
          value: item,
          onDelete: _this2.handleDelete
        });
      }), /*#__PURE__*/_react.default.createElement("input", {
        ref: this.fileInput,
        type: "file",
        name: "file",
        accept: acceptedFiles,
        multiple: true,
        onChange: this.handleChange,
        style: {
          cursor: 'pointer',
          display: 'none',
          height: '0',
          width: '0'
        },
        required: true
      }), canAddAnotherFile && /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
        theme: this.props.errors[this.props.name] && this.props.touched[this.props.name] ? styles : this.props.theme
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: this.handleAddFileClick,
        variant: "outlined",
        color: this.props.errors[this.props.name] && this.props.touched[this.props.name] ? 'primary' : 'default',
        style: {
          marginTop: 16
        },
        disabled: Boolean(disabled)
      }, this.props.description ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !existingFiles ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Icon, {
        style: {
          marginLeft: 25
        }
      }, "cloud_upload")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: label
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: 8,
          textTransform: 'lowercase',
          color: '#868686'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "caption",
        display: "block",
        gutterBottom: true
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: this.props.description
      })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Plus de fichiers",
        defaultMessage: "Plus de fichiers"
      }), /*#__PURE__*/_react.default.createElement(_core.Icon, {
        style: {
          marginLeft: 25
        }
      }, "cloud_upload"))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !existingFiles ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: label
      }) : /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Plus de fichiers",
        defaultMessage: "Plus de fichiers"
      }), /*#__PURE__*/_react.default.createElement(_core.Icon, {
        style: {
          marginLeft: 25
        }
      }, "cloud_upload")))));
    }
  }]);
  return MultiFileUploader;
}(_react.default.Component);
var _default = (0, _reactIntl.injectIntl)(MultiFileUploader);
exports.default = _default;